<!--
 * @Descripttion: 专家评审
 * @version: v1.0.0
 * @Author: zhoumin
 * @Date: 2020-08-22 15:50:13
 * @LastEditors: zhoumin
 * @LastEditTime: 2020-10-12 11:00:12
-->
<template>
  <div class="">
    <p class='count'>
      <span>报名数：{{totalProject}}</span>
    </p>
    <section class="filter">
      <div class="btn_wrapper">
        <span @click="goToQuota" v-if="activedType.value===2">评分指标 <i class="el-icon-data-analysis"></i></span>
        <span class="dialogDown" @click="dialogDown= true" v-show="identify==='3'">导出 <i class="el-icon-download"></i></span>
        <span class="config" @click="dialogVisible = true" v-show="identify==='3'">结果公布 <i class="el-icon-s-order"></i></span>
      </div>
      <p>
        <span v-for="item in types" :key="item.key" :class="{ actived: item.key === activedType.key }" @click="changeType(item)">{{ item.key }}</span>
      </p>
      <p>
        <el-input v-model="params.keyword" placeholder="请输入关键字" @change="getList" suffix-icon="el-icon-search"></el-input>
      </p>
    </section>
    <main>
      <el-table :data="tableData" style="width: 100%" header-row-class-name="project" header-align="center" :key="activedType.value">
        <el-table-column type="index" label="序号" width="80" align="center">
        </el-table-column>
        <el-table-column prop="applySchool" label="参赛学校" align="center">
        </el-table-column>
        <el-table-column prop="name" label="参赛人" width="150" align="center"></el-table-column>
        <el-table-column v-for="(user, index) in userCount" :key="activedType.key + index" prop="preScore" :label="user.user" align="center">
          <template slot-scope="scope">
            <div>
              {{index | toScore(scope.row.preList, userId)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="preScore" label="总分" width="100" align="center" v-if='identify==="3"'>
          <template slot-scope="scope">
            {{scope.row.preScore === -1?'评分未完成':scope.row.preScore }}
          </template>
        </el-table-column>
        <el-table-column prop="preAvgScore" label="平均分" width="100" align="center" v-if='identify==="3"'>
          <template slot-scope="scope">
            {{scope.row.preAvgScore === -1?'评分未完成':scope.row.preAvgScore }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="resultSort" label="排名" width="100" align="center" v-if='identify==="3"'> -->
        <!-- <template slot-scope="scope">
            {{scope.row.preScore === -1?'评分未完成':scope.row.preScore }}
          </template> -->
        <!-- </el-table-column> -->
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" round type="primary" size="medium">评审</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :pageSize.sync='pageSize' :currentPage.sync='currentPage' :total.sync='total' class='Pagination'></Pagination>
    </main>
    <el-dialog title="结果公布" :visible.sync="dialogVisible" width="550px" class='config_dialog' :close-on-click-modal='false'>
      <div>
        <h4>确定现在公布结果吗？公布后在专题页面展示结果</h4>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="publishProject" round>确 定</el-button>
        <el-button @click="dialogVisible = false" round>取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="结果导出" :visible.sync="dialogDown" width="550px" class='config_dialog down_dialog' :close-on-click-modal='false'>
      <div>
        <h5>请公布结果后导出正式名单</h5>
        <el-radio-group v-model="radio" ref="radio">
          <el-radio :label="1">全部名单</el-radio>
          <el-radio :label="2">进入决赛名单</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportExcel" round>确 定</el-button>
        <el-button @click="dialogDown = false" round>取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="审核" :visible.sync="checkVisible" width="550px" class='config_dialog' :close-on-click-modal='false'>
      <BasicInfo :info="checkItem"></BasicInfo>
      <el-divider></el-divider>
      <div>
        <div v-for="user in checkItem.preList" :key="user.userId" class="userList">
          <div class="name">{{user.userName}}</div>
          <div class="form_wrapper">
            <el-form ref="form" :model="user" label-width="80px">
              <el-form-item label="评分：" :rules="[{ required: true, message: '请输入评分', trigger: 'blur' }]" prop="score">
                <el-input-number size="medium" :min='0' :max='100' :precision="1" :step="0.1" v-model="user.score"></el-input-number>
              </el-form-item>
              <el-form-item label="评语：" :rules="[ { min: 0, max: 500, message: '500字内', trigger: 'blur' }]" prop="desc">
                <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="user.desc">
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkProject" round>提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination/Pagination";
import BasicInfo from "../../components/BasicInfo";
import {
  $getList,
  $getPublishList,
  $getStatistics,
  $getDetail,
  $preCheck,
  $publishProject,
  $exportExcel
} from "../../api/activity/two/compete/manage.js";
import { $getJudegesUserList } from "../../api/activity/two/config/manage.js";
export default {
  name: "",
  components: {
    Pagination,
    BasicInfo
  },
  filters: {
    toGroupName(val) {
      const a = {
        1: "中职组",
        2: "高职组",
        3: "应用型本科组"
      };
      return a[val];
    },
    toScore(val, list, userId) {
      const id = localStorage.identify === "3" ? list[val].userId : userId;
      const obj = list.find(res => res.userId === id);
      return obj && obj.score ? obj.score : "暂未评分";
    }
  },
  data() {
    return {
      pageSize: 20,
      currentPage: 1,
      total: 200,
      types: [],
      activedType: {},
      dialogVisible: false,
      tableData: [],
      totalSchool: 0,
      totalProject: 0,
      params: {
        page: 1,
        rows: 20,
        group: 2,
        keyword: "",
        type: 2
      },
      checkItem: {
        preList: [
          {
            score: ""
          }
        ]
      },
      checkVisible: false,
      dialogDown: false,
      userList: [],
      userCount: [],
      identify: "",
      userId: "",
      radio: 1
    };
  },
  watch: {
    pageSize() {
      this.params.rows = this.pageSize;
      if (
        this.currentPage !== 1 &&
        this.total / this.pageSize < this.currentPage
      ) {
        return;
      }
      this.getList();
    },
    currentPage() {
      this.params.page = this.currentPage;
      this.getList();
    }
  },
  methods: {
    changeStatus(item) {
      this.activedStatus = item;
      this.params.status = item.value;
      this.getList();
    },
    changeType(item) {
      this.activedType = item;
      this.params.group = item.value;
      this.getList();
    },
    getList() {
      $getList(this.params).then(
        res => {
          this.total = res.totalSize;
          this.tableData = res.resultList;
          this.setUserCount();
        },
        () => {
          setTimeout(() => {
            this.$router.push({ name: "Home" });
          }, 3000);
        }
      );
    },
    getStatistics() {
      $getStatistics({ type: 2 }).then(res => {
        this.totalSchool = res.totalSchool;
        this.totalProject = res.totalProject;
      });
    },
    handleEdit(item) {
      $getDetail({ id: item.id }).then(res => {
        this.checkVisible = true;
        res.preList.forEach(e => {
          if (e.score === 0) {
            e.score = undefined;
          }
          e.desc = e.checkDesc;
        });
        if (this.identify === "2") {
          const list = res.preList.filter(res => res.userId === this.userId);
          res.preList = list;
        }
        this.checkItem = res;
      });
    },
    checkProject() {
      const p = this.$refs.form.map(f => f.validate());
      Promise.all(p).then(res => {
        const params = {
          preCheckList: this.checkItem.preList,
          id: this.checkItem.id
        };
        $preCheck(params).then(res => {
          this.$notify({
            title: "成功",
            message: "评审成功",
            type: "success"
          });
          this.checkVisible = false;
          this.getList();
        });
      });
    },
    download(item) {
      this.$utils.downloadFile(item.name, item.desc);
    },
    publishProject() {
      $publishProject({ type: 2 }).then(res => {
        this.dialogVisible = false;
        this.$notify({
          title: "成功",
          message: "公示成功",
          type: "success"
        });
      });
    },
    exportExcel() {
      const p = {
        type: this.radio
      };
      const obj = {
        1: "全部名单",
        2: "进入决赛名单"
      };
      $exportExcel(p).then(res => {
        const a = {
          name: res.fileName,
          desc: obj[this.radio]
        };
        this.dialogDown = false;
        this.download(a);
      });
    },
    goToQuota() {
      const newUrl = this.$router.resolve({
        name: "Quota"
      });
      window.open(newUrl.href, "_blank");
    },
    setUserCount() {
      if (this.identify === "3") {
        let count = 1;
        let arr = [];
        if (this.activedType.value === 1) {
          count = 5;
        } else {
          count = 3;
        }
        for (let i = 1; i <= count; i++) {
          arr.push({
            user: "专家" + i
          });
        }
        this.userCount = arr;
      } else {
        this.userCount = [
          {
            user: JSON.parse(localStorage.user).username
          }
        ];
      }
    }
  },
  created() {
    this.types = this.$enumsFront.ENUM_GROUP_TYPE_ALL;
    this.activedType = this.types[0];
    this.identify = localStorage.identify;
    this.userId = JSON.parse(localStorage.user).userId;
    this.getStatistics();
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.count {
  width: 438px;
  background: rgba(255, 235, 227, 1);
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 41px;
  margin: 0 auto;
  font-size: 22px;
  font-weight: bold;
  line-height: 55px;
  color: rgba(235, 85, 79, 1);
  text-align: center;
  span + span {
    margin-left: 40px;
  }
}
.filter {
  color: rgba(102, 102, 102, 1);
  line-height: 44px;
  p:nth-of-type(1) {
    text-align: center;
  }
  p:nth-of-type(2) {
    text-align: left;
    font-size: 20px;

    .el-input {
      float: right;
      width: 394px;
      height: 40px;
      margin-top: 20px;
      margin-bottom: 20px;
      /deep/.el-input__inner {
        border-radius: 20px;
      }
    }
  }
  label {
    margin-right: 20px;
  }
  span {
    cursor: pointer;
  }
  span.actived {
    color: rgba(235, 85, 79, 1);
    font-weight: bold;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      width: 38px;
      height: 4px;
      background: rgba(235, 85, 79, 1);
      opacity: 1;
      border-radius: 275px;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  span + span {
    margin-left: 30px;
  }
  .btn_wrapper {
    font-size: 22px;
    color: rgba(235, 85, 79, 1);
    text-align: right;
  }
}
.Pagination {
  margin: 20px 0;
}
.config_dialog {
  /deep/ .el-dialog__header {
    font-size: 16px;
    background: rgba(248, 248, 248, 1);
    line-height: 35px;
    padding-left: 20px;
    color: #333333;
    .el-dialog__title {
      line-height: 50px;
    }
  }
  /deep/ .el-dialog__body {
    font-size: 16px;
    h4 {
      color: #666666;
      font-weight: 400;
      margin-block-start: 0;
      margin-block-end: 0;
    }
    .item_info {
      > div {
        margin-bottom: 20px;
      }
    }
    label {
      display: inline-block;
      width: 120px;
      text-align: right;
    }
  }
  p {
    margin: 20px 0;
  }
  .dialog-footer {
    text-align: center;
  }
}
.userList {
  .name {
    display: inline-block;
    width: 80px;
    vertical-align: top;
    line-height: 40px;
    text-align: right;
  }
  .form_wrapper {
    display: inline-block;
    width: 400px;
  }
}
.down_dialog {
  h5 {
    padding-left: 30px;
  }
}
</style>